import {useNavigate} from 'react-router-dom';
import {useState, useEffect, useRef, useContext} from 'react';
import Instructions from '../../baseElements/Instructions';
import axios from 'axios';
import TopBar from '../../baseElements/TopBar';
import {activity_palettes} from '../../themes';
import ConfirmButton from '../../baseElements/ConfirmButton';
import SadFeedback from '../../baseElements/SadFeedback';
import HappyFeedback from '../../baseElements/HappyFeedback';
import AnimationOverlay from '../../baseElements/AnimationOverlay';
import Basket from '../../baseElements/Basket';
import WordToSort from "../../baseElements/WordToSort";
import {AppContext} from "../../AppContext";
import {checkActivityStatus, delay, generateUrl, getExerciseFromDB, getLog, randomizeWords, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;

const BACKGROUND_STYLE = activity_palettes.pink.primary;
const WIDTH_BREAKPOINT = 777;
const HEIGHT_BREAKPOINT = 571;

function WordSort() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const wordRef = useRef(null);
    const simpleBasketRef = useRef(null);
    const derivativeBasketRef = useRef(null);
    const initialWordPosition = useRef({x: 0, y: 0});
    
    const [words, setWords] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(1);
    const [levelInfo, setLevelInfo] = useState(0);
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [instructionText, setInstructionText] = useState('Quali parole sono semplici e quali sono invece derivate? Clicca sul cestino corretto!\n');
    const [loading, setLoading] = useState(true);
    
    const [leftOption, setLeftOption] = useState('Semplice');
    const [rightOption, setRightOption] = useState('Derivata');
    const [transformStyle, setTransformStyle] = useState('none');
    const [currentWord, setCurrentWord] = useState({id: 0, name: '', isSimple: false});
    const [feedback, setFeedback] = useState('');
    const [userChoice, setUserChoice] = useState('');
    const [wordToSortBackground, setWordToSortBackground] = useState('#f9f9f9');
    const [wordSortColor, setWordSortColor] = useState('black');
    const [isAnimating, setIsAnimating] = useState(false);
    const [isWordVisible, setIsWordVisible] = useState(true);
    
    
    const [flowButtons, setFlowButtons] = useState({confirm: true, nextExercise: false});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, showNextExercise,) {
        setFlowButtons({confirm: showConfirm, nextExercise: showNextExercise});
    }
    
    function resetStates() {
        setWords([]);
        setMaxSteps(0);
        setStepInfo(1);
        setTransformStyle('none');
        setCurrentWord({id: 0, name: '', isSimple: false});
        setFeedback('');
        setUserChoice('');
        setWordToSortBackground('#f9f9f9');
        setWordSortColor('black');
        setIsAnimating(false);
        setIsWordVisible(true);
        setLoading(true);
        updateButtonFlow(true, false);
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
        loadExercise()
            .then((wordsTemporary) => {
                if (wordsTemporary.length > 0) {
                    syncExerciseWithDB(wordsTemporary).then(() => setLoading(false));
                } else {
                    console.error('No words loaded');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('Error during loading or syncing:', error);
                setLoading(false);
            });
    }, [navigate]);
    
    async function loadExercise() {
        await delay(600);
        return getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let wordsTemporary = [];
                    console.log(json)
                    
                    if ('leftOption' in json.word_sort && 'rightOption' in json.word_sort) {
                        setLeftOption(json.word_sort.leftOption);
                        setRightOption(json.word_sort.rightOption);
                        generateUrl("word sort semantica").then((url) => {
                            setInstructionAudioUrl(url);
                        });
                        setInstructionText("A quale categoria appartengono queste parole derivate? Clicca sul cestino corretto");
                    } else {
                        generateUrl("word sort").then((url) => {
                            setInstructionAudioUrl(url);
                        });
                    }
                    
                    json.word_sort.parts.forEach((activity) => {
                        wordsTemporary.push({id: activity.wordId, name: activity.wordName, isSimple: activity.isSimple});
                    });
                    
                    wordsTemporary = randomizeWords(wordsTemporary);
                    
                    wordsTemporary.forEach((word, index) => {
                        word.id = index;
                    });
                    
                    setWords(wordsTemporary);
                    setMaxSteps(wordsTemporary.length);
                    setLevelInfo(level);
                    
                    return wordsTemporary;
                } else {
                    console.log(response.errorMess);
                    return [];
                }
            })
            .catch((error) => {
                console.log(error);
                return [];
            });
    }
    
    function syncExerciseWithDB(wordsTemporary) {
        return new Promise((resolve) => {
            
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercisesString = JSON.stringify(response.data);
                    const exercises = JSON.parse(exercisesString)[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let partId = -1;
                        exercise.actions.forEach((action) => {
                            if (action.part_id > partId) {
                                partId = action.part_id;
                            }
                        });
                        partId++;
                        setExerciseLog(exercise);
                        console.log('partId:', partId);
                        setCurrentWord(wordsTemporary[partId]);
                        setStepInfo(partId + 1);
                        setIsWordVisible(true);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    function logUserAction(correct, choice) {
        const progress = (currentWord.id + 1) / words.length * 100;
        const timestamp = new Date().toISOString();
        const newAction = {
            part_id: currentWord.id,
            current_word: currentWord.name,
            userChoice: choice,
            correct: correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        if (userChoice === '') {
            return;
        }
        setIsAnimating(true);
        if (userChoice === 'simple') {
            if (currentWord.isSimple) {
                logUserAction(true, 'simple');
                setFeedback('happy');
                setWordSortColor(activity_palettes.green.secondary);
                setWordToSortBackground(activity_palettes.green.tertiary);
            } else {
                logUserAction(false, 'simple');
                setFeedback('sad');
                setWordSortColor(activity_palettes.green.error_text);
                setWordToSortBackground(activity_palettes.green.error_background);
            }
        } else if (userChoice === 'derivative') {
            if (!currentWord.isSimple) {
                logUserAction(true, 'derivative');
                setFeedback('happy');
                setWordSortColor(activity_palettes.green.secondary);
                setWordToSortBackground(activity_palettes.green.tertiary);
            } else {
                logUserAction(false, 'derivative');
                setFeedback('sad');
                setWordSortColor(activity_palettes.green.error_text);
                setWordToSortBackground(activity_palettes.green.error_background);
            }
        }
        setTimeout(() => {
            setFeedback('');
            setIsAnimating(false);
            setTransformStyle('none');
            setWordSortColor('black');
            setWordToSortBackground('#f9f9f9');
            setUserChoice('');
            if (currentWord.id < words.length - 1) {
                setCurrentWord(words[currentWord.id + 1])
                setStepInfo(stepInfo + 1);
            } else {
                updateButtonFlow(false, true);
                setIsWordVisible(false);
            }
        }, 1250);
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    
    const handleSimpleWordClick = () => {
        if (currentWord.id < words.length) {
            if (window.innerWidth < WIDTH_BREAKPOINT || window.innerHeight < HEIGHT_BREAKPOINT) {
                console.log("width: " + window.innerWidth + " height: " + window.innerHeight);
                simpleBasketRef.current.parentNode.style.border = `5px solid  ${activity_palettes.pink.secondary}`;
                derivativeBasketRef.current.parentNode.style.border = 'transparent';
                setUserChoice("simple");
            } else {
                moveWordToBasket(simpleBasketRef);
                setUserChoice("simple");
            }
        }
    };
    
    const handleDerivativeWordClick = () => {
        if (currentWord.id < words.length) {
            if (window.innerWidth < WIDTH_BREAKPOINT || window.innerHeight < HEIGHT_BREAKPOINT) {
                derivativeBasketRef.current.parentNode.style.border = `5px solid  ${activity_palettes.pink.blue}`;
                simpleBasketRef.current.parentNode.style.border = 'transparent';
                setUserChoice("derivative");
            } else {
                moveWordToBasket(derivativeBasketRef);
                setUserChoice("derivative");
            }
        }
    };
    
    const updateWordPosition = () => {
        if (wordRef.current) {
            const wordRect = wordRef.current.getBoundingClientRect();
            initialWordPosition.current = {
                x: wordRect.left + wordRect.width / 2,
                y: wordRect.top + wordRect.height,
            };
        }
    };
    
    const moveWordToBasket = (basketRef) => {
        if (wordRef.current && basketRef.current) {
            
            setTransformStyle('none');
            
            const basketRect = basketRef.current.getBoundingClientRect();
            const basketCenterX = basketRect.left + basketRect.width / 2;
            const basketCenterY = basketRect.top;
            const deltaX = basketCenterX - initialWordPosition.current.x;
            const deltaY = basketCenterY - initialWordPosition.current.y - 10;
            
            setTransformStyle(`translate(${deltaX}px, ${deltaY}px)`);
        }
    };
    
    useEffect(() => {
        updateWordPosition();
        const handleResize = () => {
            setTransformStyle('none');
            setUserChoice("");
            updateWordPosition();
            simpleBasketRef.current.parentNode.style.border = 'transparent';
            derivativeBasketRef.current.parentNode.style.border = 'transparent';
        };
        
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    return (
        <div
            className="generalActivitiesBackground custom-col-12 tablet-custom-col-12"
            style={{ backgroundColor: BACKGROUND_STYLE, position: 'relative' }}
        >
            {/* 1) The Loading Page (Overlays Everything) */}
            {loading && (
                <div
                    className="loading-page"
                    style={{
                        backgroundColor: BACKGROUND_STYLE,
                    }}
                >
                    <Spinner animation="border" variant="white" />
                </div>
            )}
            
            {/* 2) The Actual Page Content, Always in the DOM */}
            <AnimationOverlay isAnimating={isAnimating} />
            <div
                className="generalActivitiesPageContent custom-col-11 tablet-custom-col-11"
                style={{
                    opacity: loading ? 0 : 1,
                    pointerEvents: loading ? 'none' : 'auto',
                    transition: 'opacity 0.3s ease'
                }}
            >
                <div className="generalActivitiesTopBarArea custom-row">
                    <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps} />
                    <Instructions
                        hasAudio={false}
                        instructionText={instructionText}
                        instructionAudioUrl={instructionAudioUrl}
                    />
                </div>
                
                <div className="generalActivitiesGameElementsArea row">
                    <div className="generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2">
                        <SadFeedback feedback={feedback.includes('sad')} />
                    </div>
                    
                    <div className="generalActivitiesColumnOneColumnLayout custom-col-8">
                        {isWordVisible && (
                            <WordToSort
                                className="custom-column-12"
                                name={currentWord.name}
                                backgroundColor={wordToSortBackground}
                                color={wordSortColor}
                                transformStyle={transformStyle}
                                ref={wordRef}
                            />
                        )}
                        <div className="generalActivitiesColumnOneRowLayout basketRow">
                            <div className="generalActivitiesColumnTwoColumnsLayout grow-flex-1">
                                <Basket
                                    name= {leftOption}
                                    backgroundColor={activity_palettes.pink.secondary}
                                    onClick={handleSimpleWordClick}
                                    ref={simpleBasketRef}
                                    isClicked={false}
                                />
                            </div>
                            <div className="generalActivitiesColumnTwoColumnsLayout grow-flex-1">
                                <Basket
                                    name= {rightOption}
                                    backgroundColor={activity_palettes.pink.blue}
                                    onClick={handleDerivativeWordClick}
                                    ref={derivativeBasketRef}
                                    isClicked={false}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2">
                        <HappyFeedback feedback={feedback.includes('happy')} />
                    </div>
                </div>
                
                <div className="generalActivitiesConfirmButtonArea custom-row">
                    {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick} />}
                    {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick} />}
                </div>
            </div>
        </div>
    );
    
}

export default WordSort;
